<script>

export default {
	name: 'IconSvgAv',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3753 4.10333C12.9106 4.10289 12.4649 3.92174 12.1362 3.59961C11.8075 3.27748 11.6225 2.84067 11.6218 2.385V0H3.78734C3.1807 0 2.59891 0.236264 2.16995 0.656815C1.74098 1.07736 1.5 1.64775 1.5 2.2425V15.7608C1.50068 16.3551 1.74199 16.9247 2.1709 17.3446C2.59981 17.7645 3.18122 18.0002 3.78734 18H13.1883C13.795 18 14.3768 17.7637 14.8057 17.3432C15.2347 16.9226 15.4757 16.3523 15.4757 15.7575V4.10333H13.3753Z"
				:fill="color" />
			<path
				d="M15.4757 4.10333H13.3754C12.9106 4.10289 12.465 3.92174 12.1362 3.59961C11.8075 3.27748 11.6225 2.84067 11.6218 2.385V0L15.4757 4.10333Z"
				fill="#0055A3" />
			<path
				d="M17.1349 14.2166H6.50645C5.75253 14.2166 5.14136 14.8157 5.14136 15.5549V18.6615C5.14136 19.4007 5.75253 19.9999 6.50645 19.9999H17.1349C17.8888 19.9999 18.5 19.4007 18.5 18.6615V15.5549C18.5 14.8157 17.8888 14.2166 17.1349 14.2166Z"
				fill="#0055A3" />
			<path d="M9.44999 17.7809V18.3867H8.80994V17.7809H9.44999Z" fill="#F3F3F6" />
			<path
				d="M11.3583 17.93H10.3995L10.2406 18.3867H9.59033L10.5253 15.8992H11.2351L12.1701 18.3867H11.5122L11.3583 17.93ZM11.1985 17.4692L10.8806 16.5475L10.5593 17.4692H11.1985Z"
				fill="#F3F3F6" />
			<path
				d="M12.891 15.8809L13.5167 17.7667L14.1422 15.8809H14.8052L13.9162 18.3867H13.1171L12.2314 15.8809H12.891Z"
				fill="#F3F3F6" />
			<path
				d="M8.47419 12.4858C7.54688 12.4847 6.65787 12.123 6.00216 11.4802C5.34645 10.8373 4.97757 9.96574 4.97644 9.0566C4.97757 8.14747 5.34645 7.27589 6.00216 6.63304C6.65787 5.99018 7.54688 5.62854 8.47419 5.62744C9.40151 5.62854 10.2905 5.99018 10.9462 6.63304C11.6019 7.27589 11.9708 8.14747 11.9719 9.0566C11.9708 9.96574 11.6019 10.8373 10.9462 11.4802C10.2905 12.123 9.40151 12.4847 8.47419 12.4858ZM8.47419 6.22827C7.70948 6.22959 6.97648 6.528 6.43575 7.05813C5.89502 7.58826 5.59065 8.30689 5.5893 9.0566C5.5893 9.80719 5.89308 10.5271 6.43395 11.0583C6.97483 11.5895 7.7086 11.8886 8.47419 11.8899C9.23978 11.8886 9.97356 11.5895 10.5144 11.0583C11.0553 10.5271 11.3591 9.80719 11.3591 9.0566C11.3577 8.30689 11.0534 7.58826 10.5126 7.05813C9.9719 6.528 9.2389 6.22959 8.47419 6.22827Z"
				fill="#0055A3" />
			<path
				d="M9.47739 8.82171L8.66393 8.36171C8.62183 8.33788 8.57407 8.32533 8.52545 8.32532C8.47684 8.32531 8.42907 8.33783 8.38696 8.36164C8.34484 8.38546 8.30985 8.41971 8.28551 8.46097C8.26117 8.50223 8.24834 8.54905 8.24829 8.59671V9.51755C8.24834 9.56521 8.26117 9.61202 8.28551 9.65328C8.30985 9.69455 8.34484 9.7288 8.38696 9.75261C8.42907 9.77643 8.47684 9.78895 8.52545 9.78894C8.57407 9.78893 8.62183 9.77638 8.66393 9.75255L9.47739 9.29171C9.51938 9.26783 9.55424 9.23355 9.57847 9.19231C9.6027 9.15107 9.61546 9.10431 9.61546 9.05671C9.61546 9.00912 9.6027 8.96236 9.57847 8.92111C9.55424 8.87987 9.51938 8.84559 9.47739 8.82171Z"
				fill="#0055A3" />
			<path
				d="M7.83086 8.29004H7.53336C7.42257 8.29004 7.33276 8.37809 7.33276 8.4867V9.62754C7.33276 9.73616 7.42257 9.82421 7.53336 9.82421H7.83086C7.94165 9.82421 8.03146 9.73616 8.03146 9.62754V8.4867C8.03146 8.37809 7.94165 8.29004 7.83086 8.29004Z"
				fill="#0055A3" />
		</svg>
	</div>
</template>

<style scoped>

</style>